// extracted by mini-css-extract-plugin
export default {"wrapper":"Uk","form":"Vk","required":"Wk","label":"Xk","small":"Yk","noMargin":"Zk","success":"_k","circle":"al","successText":"bl","appointment":"cl"};